import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ServerGroups } from '../../relay/interfaces/DashboardServer.interface';
import { CardTableHeader } from '../card-table/models/card-table-header.model';
import { CardTableAction, CardTableOptions } from '../card-table/models';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';

@Component({
  selector: 'app-group-servers-modal',
  templateUrl: './group-servers-modal.component.html',
  styleUrls: ['./group-servers-modal.component.scss'],
})
export class GroupServersModalComponent implements OnInit {
  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: true,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };
  headers: CardTableHeader[] = [
    {
      ID: 'ID',
      Text: 'ID',
      Width: 30,
    },
    {
      ID: 'Name',
      Text: 'Name',
      Width: 30,
    },
    {
      ID: 'IPAddress',
      Text: 'IPAddress',
      Width: 30,
    },
  ];

  ScreenSize = ScreenSize;
  dataSource = this.data.serverData;
  dataToShow = this.data.serverData;
  groupForm: UntypedFormGroup;
  selection = new SelectionModel<any>(true, []);
  unassignedGroup: number[];
  showValidation = false;
  selectionMap = {};
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GroupServersModalComponent>,
    private genericService: GenericService,
    private endpoints: Endpoints,
  ) {}

  ngOnInit(): void {
    let unassignedGroupArray = this.data.groups.filter((x: ServerGroups) => x.GroupName == 'Unassigned');
    if (unassignedGroupArray.length > 0) {
      this.unassignedGroup = unassignedGroupArray[0].Servers.map((x) => x.ID);
    } else {
      this.unassignedGroup = [];
    }
    this.groupForm = new UntypedFormGroup({
      groupName: new UntypedFormControl({ value: '', disabled: this.dataToShow.length == 0 }),
    });

    this.data.serverData.forEach((element) => {
      this.selectionMap[element.ID] = false;
    });

    console.log(this.selectionMap);
  }

  selectionMade(event: any) {
    this.selectionMap[event.ID] = !this.selectionMap[event.ID];
    this.validate();
    console.log(this.selectionMap);
  }

  closeModal() {
    this.dialogRef.close();
  }

  OnPageChange(event: any) {
    const startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.dataSource.data.length) {
      endIndex = this.dataSource.data.length;
    }
    this.dataToShow.data = this.dataSource.data.slice(startIndex, endIndex);
  }

  validate() {
    let found = false;

    Object.entries(this.selectionMap).forEach(([key, element]) => {
      if (!this.unassignedGroup.includes(parseInt(key)) && element == true) {
        found = true;
      }
    });
    this.showValidation = found;
  }

  addToGroup() {
    let IDs: any = [];
    Object.entries(this.selectionMap).forEach(([key, element]) => {
      if (element == true) {
        IDs.push(parseInt(key));
      }
    });
    let objectToSend = {
      ServerIDs: IDs,
      GroupName: this.groupForm.value.groupName ? this.groupForm.value.groupName : '',
    };
    this.genericService.PUT(this.endpoints.SET_RELAY_GROUP_NAMES, objectToSend).subscribe(
      (data) => {
        window.location.reload();
        // this.genericService.createToast("Success", "Servers successfully grouped", "success");
      },
      (error) => {
        // this.genericService.createToast("Error", "Error grouping servers", "error");
      },
    );
    this.dialogRef.close(objectToSend);
  }
}
